import { render } from "./StudentsOverviewChart.vue?vue&type=template&id=27873379&ts=true"
import script from "./StudentsOverviewChart.vue?vue&type=script&lang=ts"
export * from "./StudentsOverviewChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__